export default "__VITE_ASSET__c266a2dc__"